import { createSlice } from "@reduxjs/toolkit";

const load = () => {
  try {
    const s = localStorage.getItem("cart:v1");
    return s ? JSON.parse(s) : { items: [] };
  } catch (e) {
    return { items: [] };
  }
};

const save = (state) => {
  try {
    localStorage.setItem("cart:v1", JSON.stringify(state));
  } catch (e) {}
};

const cartSlice = createSlice({
  name: "cart",
  initialState: load(),
  reducers: {
    addItem(state, action) {
      const item = action.payload;
      const idx = state.items.findIndex((i) => i.id === item.id);
      if (idx >= 0) {
        state.items[idx].qty = (state.items[idx].qty || 1) + (item.qty || 1);
      } else {
        state.items.push({ ...item, qty: item.qty || 1 });
      }
      save(state);
    },
    removeItem(state, action) {
      state.items = state.items.filter((i) => i.id !== action.payload);
      save(state);
    },
    clearCart(state) {
      state.items = [];
      save(state);
    },
    setQty(state, action) {
      const { id, qty } = action.payload;
      const idx = state.items.findIndex((i) => i.id === id);
      if (idx >= 0) {
        state.items[idx].qty = qty;
      }
      save(state);
    },
  },
});

export const { addItem, removeItem, clearCart, setQty } = cartSlice.actions;
export default cartSlice.reducer;
